import React, { useState, useEffect, Fragment } from "react";
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from "react-router-dom";
import { Col, Row, Label, FormGroup, Input, Card, CardBody } from "reactstrap";
import { Form, Field } from "react-final-form";
import moment from 'moment';

import LoadingOverlay from "react-loading-overlay-ts";
import DNALoader from "../../../../components/Loaders/DnaLoader.js";
import "../../../../assets/custom css/loadoverlay.scss";

import Alerts from "../../../../components/Alerts/alerts.js";

import PaymentService from "./payments.service.js";
import AuthService from "../../../Authentication/auth.service.js";
import AlertService from "../../../../components/Alerts/alerts.js";


const AddUser = () => {

  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state.row;
  const [loading, setLoading] = useState(false);
  const [CreditReceipt, setCreditReceipt] = useState('');

  useEffect(() => {
    i18n.changeLanguage(localStorage.getItem('language'));
  }, []);

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    const paymentDateInput = document.getElementById('payment_date');

    if (paymentDateInput) {
      paymentDateInput.setAttribute('max', today);
    }
  }, []);

  const onSubmit = values => {
    //iph todo: 47
    //console.log(values);
    var payloadData = {
      functionName: "AdjustCreditNote",
      invoice_number: values.invoice_number,
      credit_note_amount: parseFloat(values.credit_note_amount).toFixed(2),
      customer_id: state?.user_details?._id,
      order_id: state?.order_id,
      payment_date: values.payment_date,
      CreditReceipt: CreditReceipt,
      invoice_id: state?._id ? state?._id : null,
    }
    //iph todo: 47
    //console.log(payloadData);
    setLoading(true);
    PaymentService.AdjustCreditNote(payloadData).then((response) => {
      //iph todo: 47
      //console.log("API Response:-", response);
      setLoading(false);
      if (response.data.status) {
        if (state.check) {
          localStorage.setItem('tab5', "5");
        }

        navigate(-1)
        if (response.data.message !== '') {
          Alerts.swalSuccessAlert(response.data.message)
        }
        else {
          Alerts.swalSuccessAlert(t("Payment Added Successfully."));
        }
      }
      else {
        if (response.data.message !== '') {
          if (response.data.message === "Unauthorized") {
            AuthService.logout();
            navigate("/login");
            window.location.reload();
          }
          else {
            Alerts.swalErrorAlert(response.data.message);
          }
        }
        else {
          Alerts.swalErrorAlert(t("Error: Can't add Payment at the moment. Please try again later."))
        }
      }
    },
      (error) => {
        setLoading(false);
        Alerts.swalErrorAlert(t("Network Operation failed."))
      });

  }


  const validateFtn = (values) => {
    const errors = {};
    if (!CreditReceipt) {
      errors.CreditReceipt = t("Credit Receipt is required");
    }


    return errors;
  };

  const onCreditFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      //iph todo: 47
      //console.log(e.target.files)
      var filename = e.target.files[0].name
      //iph todo: 47
      //console.log("File Name", filename)
      var fileReader = new FileReader();
      fileReader.readAsDataURL(e.target.files[0])
      fileReader.onload = () => {
        const convertedPDF = fileReader.result
        //iph todo: 47
        //console.log("Converted PDF File:-", convertedPDF)
        setCreditReceipt(convertedPDF);
      }
    } else {
      setCreditReceipt('');
    }

  }

  const initialValues = {
    invoice_number: state?.invoice_number || '',
    payment_date: moment().format("YYYY-MM-DD"),
    credit_note_amount: state?.credit_note_amount || 0,
  };

  return (
    <Fragment>
      <div className="app-main__outer">
        <div className="app-main__inner">
          <div className="app-page-title">
            <div className="page-title-wrapper justify-content-left">
              <div className="page-title-heading fw-bold">
                <div className="page-title-icon">
                  <i className="pe-7s-add-user icon-gradient bg-happy-green" />
                </div>
                <div>{t(`Adjust credit Note for Invoice ${state.invoice_number}`)}
                  <div className="page-title-subheading">
                    {t('Fill the form below to Adjust credit Note details for invoice.')}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center">
            <div className="col-md-12">
              <Card className="main-card mb-3">
                <CardBody>
                  <Form onSubmit={onSubmit}
                    validate={validateFtn}
                    initialValues={initialValues}
                    render={({ handleSubmit, values, submitting, validating, valid }) => (
                      <form onSubmit={handleSubmit}>
                        <LoadingOverlay tag="div" active={loading}
                          styles={{ overlay: (base) => ({ ...base }) }}
                          spinner={<DNALoader />}>
                          <Row>
                            <Col md={6}>
                              <FormGroup>
                                <Field name="invoice_number">
                                  {({ input, meta }) => (
                                    <div>
                                      <Label for="invoice_number">{t('Invoice Number')}</Label>
                                      <Input {...input} type="text"
                                        invalid={meta.error && meta.touched}
                                        placeholder={t('Invoice Number')}
                                        disabled
                                      />
                                      {meta.error && meta.touched &&
                                        <span className="text-danger">{meta.error}</span>}
                                    </div>
                                  )}
                                </Field>
                              </FormGroup>
                              <FormGroup>
                                <Field name="credit_note_amount">
                                  {({ input, meta }) => {
                                    // Function to format the input value as a decimal with two decimal places

                                    return (
                                      <div>
                                        <Label for="credit_note_amount">{t(`Credit Note Amount (${localStorage.getItem("currency")})`)}</Label>
                                        <Input
                                          {...input}
                                          type="number"
                                          disabled={true}
                                          value={parseFloat(input.value).toFixed(2)}
                                          invalid={meta.error && meta.touched}
                                          placeholder={t('Credit Note Amount')}
                                        />
                                        {meta.error && meta.touched && (
                                          <span className="text-danger">{meta.error}</span>
                                        )}
                                      </div>
                                    );
                                  }}
                                </Field>
                              </FormGroup>


                              <FormGroup>
                                <Field name="customer_id" initialValue={state.user_details ? state?.user_details[localStorage.getItem('invoice_to_field')] : ''}>
                                  {({ input, meta }) => (
                                    <div>
                                      <Label for="customer_id">{t('Customer Name')}</Label>
                                      <Input {...input} type="text"
                                        invalid={meta.error && meta.touched}
                                        placeholder="Customer"
                                        disabled
                                      />
                                      {meta.error && meta.touched &&
                                        <span className="text-danger">{meta.error}</span>}
                                    </div>
                                  )}
                                </Field>
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <FormGroup>
                                  <Field name="payment_date">
                                    {({ input, meta }) => {
                                      return (
                                        <div>
                                          <Label for="payment_date">{t('Payment Date')}</Label>
                                          <Input
                                            {...input}
                                            type="date"
                                            id="payment_date"
                                            defaultValue={input.value}
                                            invalid={meta.error && meta.touched}
                                          />
                                          {meta.error && meta.touched && (
                                            <span className="text-danger">{meta.error}</span>
                                          )}
                                        </div>
                                      );
                                    }}
                                  </Field>
                                </FormGroup>

                              </FormGroup>

                              <FormGroup>
                                <Field name="credit_note_receipt">
                                  {({ input, meta }) => (
                                    <div>
                                      <Label for="method">{t('Credit Note Receipt')}</Label>
                                      <Input
                                        name="file"
                                        type='file'
                                        onChange={(e) => {
                                          onCreditFileChange(e);
                                          input.onChange(e);
                                        }}
                                      />
                                      {meta.error && meta.touched &&
                                        <span className="text-danger">{meta.error}</span>}
                                    </div>
                                  )}
                                </Field>
                              </FormGroup>
                            </Col>
                            <FormGroup>
                              <div className="d-flex justify-content-center">
                                <button type="button" onClick={() => {
                                  if (state.check) {
                                    localStorage.setItem('tab5', "5");
                                  }
                                  navigate(-1)
                                }} className="btn btn-outline-light btn-hover-shine me-3 mt-3">{t('Cancel')}</button>
                                <button className="btn btn-custom-color btn-hover-shine me-3 mt-3" disabled={!valid} >{t('Adjust Credit Note!')}</button>
                              </div>
                            </FormGroup>
                          </Row>
                        </LoadingOverlay>
                      </form>
                    )}
                  />
                </CardBody>
              </Card>
            </div>
          </div>

        </div>
      </div>
    </Fragment >
  );

};
export default AddUser